/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCommissionStatementDtoFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type CommissionStatementDto, type ErrorResponse, type InternalErrorResponse } from '../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/commissions/statements/by-sales-rep/{salesRepId}
 */
export interface WithSalesRepItemRequestBuilder extends BaseRequestBuilder<WithSalesRepItemRequestBuilder> {
    /**
     * Matches on overlap, not containment: a statement is returned when any part of its period falls inside the dates asked for, so a quarterly statement shows up for a query about a single week within it. Results come back newest period first, and deleted statements are left out — unlike the general statements listing, which includes them. This one is not paged and returns a plain array, so a wide date range on a long-serving rep returns everything at once.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CommissionStatementDto[]>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<WithSalesRepItemRequestBuilderGetQueryParameters> | undefined) : Promise<CommissionStatementDto[] | undefined>;
    /**
     * Matches on overlap, not containment: a statement is returned when any part of its period falls inside the dates asked for, so a quarterly statement shows up for a query about a single week within it. Results come back newest period first, and deleted statements are left out — unlike the general statements listing, which includes them. This one is not paged and returns a plain array, so a wide date range on a long-serving rep returns everything at once.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<WithSalesRepItemRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Matches on overlap, not containment: a statement is returned when any part of its period falls inside the dates asked for, so a quarterly statement shows up for a query about a single week within it. Results come back newest period first, and deleted statements are left out — unlike the general statements listing, which includes them. This one is not paged and returns a plain array, so a wide date range on a long-serving rep returns everything at once.
 */
export interface WithSalesRepItemRequestBuilderGetQueryParameters {
    endDate?: Date;
    startDate?: Date;
    useOrganizationId?: string;
}
/**
 * Uri template for the request builder.
 */
export const WithSalesRepItemRequestBuilderUriTemplate = "{+baseurl}/api/commissions/statements/by-sales-rep/{salesRepId}?endDate={endDate}&startDate={startDate}{&useOrganizationId*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const WithSalesRepItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: WithSalesRepItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createCommissionStatementDtoFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
